module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAaCAYAAAGhnG6pAAAAAXNSR0IArs4c6QAAAVJJREFUSA3tVjFuwkAQtKOkoMkTqCKlpE+dD/CQSPkAfXoKyvwhJS8Ahw5ayrwgTSQkwizsRHvOOpy9iALlpNPuzc7Ontfnk8tCxzfG3oVdEiRwiChaMsqUPcAFg6mtRzNSUoGiEAkdj7AzLmjr/OY1MipmWducwQjYffqeLUVOAiUGfUu81sWEJBvM8n91v571Q7ABby82flpfqumouii7rWtqqVtAq3/B3riELiDE3HOjxRITfQuLqECXBzx1DjryFtI0LR10EaofpDUO0Z0IiXCGYGVvHW7mlQIE/rJWYAvibUbVlKLqoxQ94yp6EuNH2d2B1wHplYdHsasWAu8tuLnURS7xgnn6HYj5xHzGbPNa4p2Rys7YAHvB7MUrHFFwinvQmDJeMIIda/cHCg9xwz5xA7Bz40dd9zZe4YkeosrZ+SgmP55TzPvspEsi/l/FOzwBBFei4RL+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shelf-list/expand.png
// module id = Jj4o
// module chunks = 1